// extracted by mini-css-extract-plugin
export var card = "_5z-0";
export var expandedCard = "_5z-2";
export var paginated = "_5z-1";